import React, { PureComponent } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, Modal, Ref } from 'semantic-ui-react'
import { getPlanPermissions, updatePlanPermission, getUserPlanPermissionMatrixValues } from '../actions/plan_permission'
import { getUsers } from '../actions/user'
import { connect } from 'react-redux';
import FormHeader from './userPlanPermissionTable/formHeader'
import ToggleColumnCell from './userPlanPermissionTable/toggleColumnCell'
import UserColumnCell from './userPlanPermissionTable/userColumnCell'
import MatrixColumnCell from './userPlanPermissionTable/matrixColumnCell'
import ElementLoader from './element_loader'

import { findObjectByKeyValue } from '../helpers';

class UserPlanPermissionTableComponent extends PureComponent {
  constructor(props){
    super(props)
    this.formMode = Boolean(this.props.formMode)

    this.state = {
      data: [],
      columns: this.formMode ? [] : this.initialMatrixHeaders(),
      plans: [],
      planPermissions: {},
      tagFilters: [],
      allCan: null,
      loading: true,
    }

    this.multiTruncateStyle = { height: '100%', overflow: 'hidden', display: '-webkit-box',
                                WebkitLineClamp: '2', WebkitBoxOrient: 'vertical' }
  }

  componentDidMount(){
    if( this.formMode ){
      this.setState({ columns: this.formColumns() })
      this.getFormPlanPermissions()
      return
    }

    this.getUserPlanPermissionMatrixValues();
  }

  getUserPlanPermissionMatrixValues = () => {
    const filter = { plan_ids: this.props.filter.planIds }

    this.props.getUserPlanPermissionMatrixValues(filter).then( () => {

      const planPermissions = {}
      this.props.planPermissions.forEach( planPermission => {
        planPermissions[`${planPermission.user_id}_${planPermission.plan_id}`] = planPermission
      });
      this.setState({
        searchTerm: this.props.filter.searchTerm,
        tagFilters: this.props.filter.tagFilters,
        planPermissions: planPermissions,
        data: this.props.matrixUsers,
      }, () => this.setState({ columns: this.planColumns(), loading: false }) )
    })
  }

  getFormPlanPermissions = () => {
    this.props.getUsers({ not_admin: true }).then(() => {
      const planPermissions = []
      this.props.users.forEach( (user,i) => {
        const permission = findObjectByKeyValue(this.props.permissions, user.id, 'user_id');
        const can_read = permission ? permission.can_read : false
        const can_update = permission ? permission.can_update : false

        planPermissions.push({
            id: i,
            user_name: `${user.profile.first_name} ${user.profile.last_name}`,
            user_id: user.id,
            can_read: can_read,
            can_update: can_update
          })
       })

      this.setState({ data: planPermissions, loading: false })
    })
  }

  formColumns = () => {
    return [
      { dataField: 'user_name',
        text: this.props.translations.name,
        headerTitle: true,
        editable: false,
        formatter: row => <UserColumnCell userName={row}/>,
      },{
        dataField: 'permission',
        text: "",
        formatter: this.formColumnFormatter,
        headerFormatter: this.formColumnHeaderFormatter,
        editable: false,
      }
    ]
  }

  formColumnFormatter = ( cell, row, rowIndex, formatExtraData ) => {
    return <ToggleColumnCell onClick={this.toggleFormPermissionButton.bind(this, row, rowIndex)}
                   className="button-cell-two"
                   permission={row} />
  }

  toggleFormPermissionButton(oldPlanPermission, rowIndex, e){
    e.stopPropagation();
    const planPermission = { ...oldPlanPermission }
    if(!planPermission.can_read && !planPermission.can_update){
      planPermission.can_read = true
    } else if ( planPermission.can_read && planPermission.can_update ) {
      planPermission.can_read = false
      planPermission.can_update = false
    } else if ( planPermission.can_read ){
      planPermission.can_update = true
    }

    let newAllCan = null
    const planPermissions = [...this.state.data]
    planPermissions[rowIndex] = planPermission

    this.setState({ data: planPermissions, allCan: newAllCan })
  }

  formColumnHeaderFormatter = column => {
    return <FormHeader onClick={this.formHandleHeaderChange} />
  }

  formHandleHeaderChange = (e, status) => {
    e.stopPropagation();
    const planPermissions = this.state.data
    let newAllCan = null
    let newRead = false
    let newUpdate = false

    if( status === "all_can_update" ){
      newRead = true
      newUpdate = true
    } else if ( status === "all_can_read" ){
      newRead = true
      newUpdate = false
    }

    this.setState({
      data: planPermissions.map( plan => {
        return { ...plan, can_read: newRead, can_update: newUpdate }
      })
    })
  }

  initialMatrixHeaders = () => {
    const columns = [{ dataField: 'id',
      text: '',
      headerTitle: true,
      headerStyle: { width: '130px', top: 0, left: 0, position: 'sticky', backgroundColor: 'white'},
      style: { width: '130px'},
      editable: false,
    }]
    this.props.plans.forEach( plan => {
      const column = {}
      column.editable = false
      column.text = plan.name
      column.headerStyle = { width: '100px' }
      column.dataField = (plan.id).toString()
      column.headerFormatter = column => <div className="text-align-center" style={this.multiTruncateStyle} title={column.text}>
        <p>{column.text}</p>
      </div>
      columns.push(column)
    })
    return columns
  }

  planColumns = () => {
    const columns = [{ dataField: 'id',
      text: '',
      headerTitle: true,
      headerStyle: { width: '130px', top: 0, left: 0, position: 'sticky', backgroundColor: 'white'},
      style: { width: '130px'},
      formatter: (column, user) => {
        const profile = user.profile || {}
        return <UserColumnCell userName={`${profile.first_name} ${profile.last_name}`} />
      },
      editable: false,
    }]

    this.props.plans.forEach( plan => {
      const column = {}
      column.editable = false
      column.text = plan.name
      column.headerStyle = { width: '100px' }
      column.style = { width: '100px' }
      column.dataField = (plan.id).toString()

      column.formatter = ( _, user) => <MatrixColumnCell user={user} plan={plan}
                                                         planPermission={this.state.planPermissions[`${user.id}_${plan.id}`]}
                                                         planPermissionError={this.props.planPermissionError}
                                                         updatePlanPermission={this.props.updatePlanPermission}/>,

      column.headerFormatter = column => <div className="text-align-center" style={this.multiTruncateStyle} title={column.text}>
        <p>{column.text}</p>
      </div>

      columns.push(column)
    })

    return columns
  }

  renderTags = () => {
    if( this.state.tagFilters && this.state.tagFilters.length > 0 ){
      return <span>
        <span style={{color: '#337ab7'}}>Filtered by Tags:</span> { this.state.tagFilters.map( tag =>  <span key={tag} className='tag plan-tag'>{tag}</span>) }
      </span>
    }
  }

  renderSearchedBy = () => {
    return this.state.searchTerm && this.state.searchTerm !== "" && <span className="font-weight-normal" style={{marginRight: '24px'}}>

      <span style={{color: '#337ab7'}}>Searched:</span> {this.state.searchTerm}
    </span>
  }

  formSave = e => {
    this.props.close(e, this.state.data)
  }

  handleTableMatrix = ref => {
    if(this.formMode){ return }
    const headerTable = ref.getElementsByTagName("table")[0]
    const table = ref.getElementsByTagName("table")[1];
    const container = table.parentElement

    // Create fixed headers
    headerTable.style.tableLayout = 'fixed'
    const header = table.getElementsByTagName('thead')[0]
    headerTable.appendChild(header.cloneNode(true))
    header.remove()

    const hasHorizontalScrollbar = headerTable.parentElement.scrollWidth > headerTable.parentElement.clientWidth;

    if( hasHorizontalScrollbar ){
      headerTable.parentElement.style.overflow = "hidden"
      const bottomScrollbar = ref.getElementsByClassName("bottom-scrollbar")[0]
      bottomScrollbar.style.overflowX = 'scroll'
      bottomScrollbar.style.overflowY = 'hidden'
      bottomScrollbar.onscroll = e => {
        container.scrollLeft = e.target.scrollLeft
        headerTable.parentElement.scrollLeft = e.target.scrollLeft
      }

      const filler = bottomScrollbar.children[0]
      filler.style.height = '1px'
      filler.style.width = `${headerTable.parentElement.scrollWidth}px`
    } else {
      headerTable.parentElement.style.overflow = "hidden"
    }
  }

  render(){
    const { open, translations } = this.props
    let size = "large"
    let saveText = translations.close
    let save = this.props.close
    let close = this.props.close
    let contentClassName = "scrolling matrix-scrolling-table padding-0 position-relative"
    let wrapperClassName = "table-scroll table-button-cell compact-column"

    if(this.formMode){
        size = "small"
        saveText = translations.save
        save = this.formSave
        contentClassName = "position-relative"
        wrapperClassName = "table-button-cell compact-column form-user-plan-table"
    }

    return <Modal className='user-form-modal' size={size} open={ open }>
      <Modal.Header>
        <div className="flex">
          <span style={{flexGrow:1}}>User Permissions</span>
          <div className="font-weight-normal d-inline" style={{fontSize: '14px',flexGrow:2}}>
            {this.renderSearchedBy()}
            {this.renderTags()}
          </div>
          <div></div>
        </div>

      </Modal.Header>

      <Ref innerRef={this.handleTableMatrix}>
        <div>
          <div className="table-scroll table-button-cell compact-column" style={{overflow: 'hidden scroll'}}>
            <table className="table table-striped table-bordered table-condensed"></table>
          </div>

          <Modal.Content className={contentClassName}>
            <ElementLoader isLoading={this.state.loading} />
            <div className={wrapperClassName}>
              <BootstrapTable
                bordered={false}
                keyField="id"
                noDataIndication={() => <div style={{height: '15vh', paddingTop: '5vh'}}><i className="file alternate icon"></i>No users available</div>}
                rowStyle={{ borderColor: 'transparent !imporant'}}
                striped
                condensed
                style={{ borderColor: 'transparent !important' }}
                data={this.state.data}
                columns={this.state.columns} />
            </div>
          </Modal.Content>
          <div className="bottom-scrollbar">
            <div></div>
          </div>
        </div>
      </Ref>

      <Modal.Actions>
        <div>
          <Button color='teal' fluid size='medium' className="new-plan-button" onClick={save}>
            {saveText}
          </Button>
        </div>
      </Modal.Actions>
      <i className="delete icon" onClick={close}></i>
    </Modal>
  }
}

const mapStateToProps = (state) => {
  return {
    planPermission: state.plan_permission.planPermission,
    planPermissions: state.plan_permission.planPermissions,
    planPermissionError: state.plan_permission.error,
    matrixUsers: state.plan_permission.users,
    users: state.user.users,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers: options => dispatch(getUsers(options)),
    getPlanPermissions: options => dispatch(getPlanPermissions(options)),
    updatePlanPermission: options => dispatch(updatePlanPermission(options)),
    getUserPlanPermissionMatrixValues: options => dispatch(getUserPlanPermissionMatrixValues(options)),
  }
}

const UserPlanPermissionTable = connect(mapStateToProps, mapDispatchToProps)(UserPlanPermissionTableComponent)
export default UserPlanPermissionTable;



// WEBPACK FOOTER //
// ./src/components/user_plan_permission_table.js